export enum ApartmentType {
  Flat = 'flat',
  Atelier = 'atelier',
  Penthouse = 'penthouse',
  Loft = 'loft',
  Maisonette = 'maisonette',
  Unit = 'unit',
}

export enum ApartmentFloor {
  First = 'first',
  Last = 'last',
  Other = 'other',
}

export enum ApartmentHeating {
  Central = 'central',
  District = 'district',
  Other = 'other',
}

export enum ApartmentReconstruction {
  Without = 'without',
  Completed = 'complete',
  Partial = 'partial',
}

export interface ApartmentUnit {
  apartmentNumber: string
  apartmentBusinessDesignation: string
  apartmentLayout: 1 | 2 | 3 | 4 | 5
  apartmentType: ApartmentType
  apartmentArea?: number
  apartmentFrontyardArea?: number
  apartmentTerraceArea?: number
  apartmentCellarArea?: number
  apartmentReconstruction?: ApartmentReconstruction
  apartmentGarages?: number
  apartmentFloor: ApartmentFloor
  apartmentHeating: ApartmentHeating
}
export const ApartmentUnitProperties = [
  'apartmentNumber',
  'apartmentBusinessDesignation',
  'apartmentLayout',
  'apartmentType',
  'apartmentArea',
  'apartmentFrontyardArea',
  'apartmentTerraceArea',
  'apartmentCellarArea',
  'apartmentGarages',
  'apartmentFloor',
  'apartmentHeating',
  'apartmentReconstruction',
]

export enum HouseStatus {
  State1,
}

export enum HouseLocation {
  Single = 'single',
  Terraced = 'terraced',
  Block = 'block',
}

export enum HouseSpecification {
  Standard = 'standard',
  Passive = 'passive',
  Wood = 'wood',
}

export enum HouseSize {
  Single = 1,
  Multi = 2,
}

export enum HouseHeating {
  Electric = 'electric',
  Gas = 'gas',
  Solid = 'solid',
}

export interface HouseUnit {
  houseNumber: string
  houseStatus: HouseStatus
  houseLayout: 1 | 2 | 3 | 4 | 5 | 0
  houseLocation: HouseLocation
  houseSpecification: HouseSpecification
  houseUsableArea?: number
  houseBuiltArea?: number
  housePlotArea?: number
  houseFloors?: number
  houseGarages?: number
  housePool?: boolean
  houseSize: HouseSize
  houseElectricity?: boolean
  houseWater?: boolean
  houseSewerage?: boolean
  housePipeline?: boolean
  houseHeating: HouseHeating
  houseSolarHeating?: boolean
  houseHeatPump?: boolean
  houseEcoBoiler?: boolean
  houseCellar?: boolean
}
export const HouseUnitProperties = [
  'houseNumber',
  'houseStatus',
  'houseLayout',
  'houseLocation',
  'houseSpecification',
  'houseUsableArea',
  'houseBuiltArea',
  'housePlotArea',
  'houseFloors',
  'houseGarages',
  'housePool',
  'houseSize',
  'houseElectricity',
  'houseWater',
  'houseSewerage',
  'housePipeline',
  'houseHeating',
  'houseSolarHeating',
  'houseHeatPump',
  'houseEcoBoiler',
  'houseCellar',
]
